import validate from "../ValidationRules/rules";

class Guest {
  constructor({ gender, age, hashtags }) {
    if (!gender || !age || !hashtags) {
      this.type = "Noninfo-Guest";
      return;
    }
    this.type = "guest";
    const validateResult = validate("guest-instance-create", {
      gender,
      age,
      hashtags,
    });
    if (!validateResult.ok) throw new Error(validateResult.messages);
    this.gender = gender;
    this.age = age;
    this.hashtags = hashtags;
  }

  getPayloadforPayment() {
    if (this.type === "Noninfo-Guest") return {};

    return {
      gender: this.gender,
      age: this.age,
      hashtags: this.hashtags,
    };
  }
}

export default Guest;
